import { useEffect, useState } from 'react';
import { useUnit } from 'effector-react';
import { $messageCentreStore, $profileFeatureStore } from '@lib/store';
import { useRouteHook } from '@shared/hooks';
import { RoutePaths } from '@shared/utils';
import { MessageThread, NewMessage } from './widgets';
import { NoData, PageContainer, Spinner } from '@shared/widgets';

export const MessageCenterPage = () => {
  const profileFeatureStore = useUnit($profileFeatureStore.store);
  const messageCentreStore = useUnit($messageCentreStore.store);

  const [isFirstLoading, setIsFirstLoading] = useState<boolean>(true);

  const { navigate } = useRouteHook();

  useEffect(() => {
    if (!profileFeatureStore.data?.messages.viewOrReply) navigate(RoutePaths.dashboard.onNavigate());

    //Auto update threads every 10sec
    $messageCentreStore.events.getThreads();
    const intervalId = setInterval(() => {
      setIsFirstLoading(false);
      $messageCentreStore.events.getThreads();
    }, 10000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const isLoading = isFirstLoading && messageCentreStore.firstLoading;
  if (!profileFeatureStore.data?.messages.viewOrReply) return null;
  return (
    <PageContainer title='Message Centre' header='Message Centre'>
      <div className='flex'>
        {messageCentreStore.loading && <Spinner position />}
        <div className='flex-1 m-win-0'>
          {isLoading ? <Spinner /> : messageCentreStore.data?.map((thread) => <MessageThread key={thread.groupId} thread={thread} />)}
          {!messageCentreStore.data || messageCentreStore.data.length === 0 ? <NoData /> : null}
        </div>
        <div className='flex-none w-80 ml-8'>
          <NewMessage />
        </div>
      </div>
    </PageContainer>
  );
};
